const config = window.config;

const env = process.env;

if (env.REACT_APP_API_URL) {
  config.apiUrl = env.REACT_APP_API_URL;
}

if (env.REACT_APP_TIMEOUT_BEFORE_REDIRECT_TO_LOGIN) {
  config.timeOutBeforeRedirectToLogin = env.REACT_APP_TIMEOUT_BEFORE_REDIRECT_TO_LOGIN;
}

if (env.REACT_APP_SECONDS_LEFT_BEFORE_REDIRECT_TO_LOGIN) {
  config.secondsLeftRedirectToLogin = env.REACT_APP_SECONDS_LEFT_BEFORE_REDIRECT_TO_LOGIN;
}

export default config;
